<div *ngIf="!Data.addfunds">
    <div class="app-nft-response">
        <div class="p-con">
            <ul class="row progressbar justify-content-center">
                <li [ngClass]="{'active' : Data.payStep < 2 }" class="step1-active">Transaction Initiated
                    <span class="dotpan" *ngIf="Data.payStep == 1"></span>
                    <span class="tickpan" *ngIf="Data.payStep == 2 || Data.payStep == 3 "></span>
                </li>
                <li [ngClass]="{'active' : Data.payStep == 2 ||  Data.payStep == 3  }"> 
                    <span *ngIf="Data.type == 'instant'">Buying NFT</span>
                    <span *ngIf="Data.type == 'auction'">Bidding NFT</span>
                    <span class="dotpan" *ngIf="Data.payStep == 2"></span>
                    <span class="tickpan" *ngIf="Data.payStep == 3"></span>
                </li>
                <li [ngClass]="{'active' : Data.payStep == 3}"> Transaction Success
                    <span class="dotpan" *ngIf="Data.payStep == 3"></span>
                    <!-- <span class="tickpan" *ngIf="payStep == 1"></span> -->
                </li>
            </ul>
        </div>
        <!-- <div class="mb-1 text-center">
            <img src="assets/Eclipse-1s-200px.svg" alt="" width="100px">
        </div> -->
        <div class="text-center">
            We are currently processing your transaction. This may take a minute <br> Please wait...
        </div>
    </div>
</div>
<div *ngIf="Data.addfunds">
    <div class="app-nft-response">
        <h1 class="text-center mb-0">Insufficient Funds</h1>
        <h3 class="text-center">Please add funds to proceed</h3>
        <div class="warning-message">
            <mat-icon class="warning-icon" color="warn">error_outline</mat-icon>
            <span class="warning-text">Running out of tokens</span>
            <button mat-flat-button color="primary" class="flat-primary-button tertiary-bg-button" [attr.style]="settingsData?.main_bg_color ? 'background-color: ' + settingsData.main_bg_color + ' !important;' : '' "
                (click)="convertTokens()">Exchange Tokens</button>
        </div>
        <p class="or-divider">or</p>
        <form [formGroup]="cryptoForm" class="app-tertiary-bg d-flex">
            <mat-form-field class="w-250 mb-10">
                <mat-label>Enter amount<span *ngIf="convRate"></span></mat-label>
                <input matInput allowValues autofocus="autofocus" isInputType="number"
                    isInputType="decimalWithTwoDigits" min="0" step="1" (blur)="onCryptoAmtChange($event.target.value)"
                     formControlName="crypto_amount" autocomplete="off"
                    required>
                <span matSuffix>
                    <!-- {{cryptoToken}} -->
                     {{data?.selectedToken === "KO+" ? "BB" : data?.selectedToken}}
                </span>
                <!-- <span matPrefix *ngIf="walletInfo?.currency">{{walletInfo?.currency |
                    currencySymbol}}&nbsp;</span>
                <span matPrefix *ngIf="!walletInfo?.currency">{{currency_for_totAmt |
                    currencySymbol}}&nbsp;</span> -->
                <mat-error *ngIf="cryptoForm.get('crypto_amount').hasError('required')">
                    Please enter amount
                </mat-error>
            </mat-form-field>
            <div class="d-flex align-items-center ml-15 mb-15 fiat-currency">
                 <span class="ml-5">{{crypto_amt_in_user_cur | currency : getCurrency}}</span>
            </div>
        </form>
        <div class="row pb-10">
            <div class="col-8">
                Processing Fee
            </div>
            <div class="col-3 text-right">
                {{ crypto_pf | currency : getCurrency}}
            </div>
        </div>
        <div class="payment-block">
            <app-saved-cards  [selectedTransaction]="crypto">
            </app-saved-cards>
            <ng-container >
                <button mat-flat-button *ngIf="savedCardsList?.length > 0 && !addNewCard"
                    class=" btn flat-primary-button mr-2 br-3 mt-5 mb-20 tertiary-bg-button"
                    (click)="addCardForCrypto()">
                    <i class="fa fa-plus pr-5" aria-hidden="true"></i>
                    Another Credit/Debit card
                </button>
            </ng-container>
            <form class="display-block" [hidden]="!addNewCard" (ngSubmit)="completeOttPayment()"
                class="checkout">
                <div id="form-field">
                    <div fxFlex="100%" class="text-center" fxLayout="column">
                        <div id="card-info" class="mb-20" #cardInfo></div>
                        <mat-error id="card-errors" role="alert" *ngIf="cardError" class="mb-20">
                            <mat-icon class="c-error">cancel
                            </mat-icon>
                            &nbsp;{{ cardError }}
                        </mat-error>
                        <div class="text-left checkbox app-merchandise app-tertiary-bg">
                            <mat-checkbox name="saveCard" class="fw-300 t_c_checkBox"
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="save_card"
                                (change)="saveCard($event)">
                            </mat-checkbox><span class="pl-3"> Save card for future payments</span>
                        </div>
                    </div>

                </div>
            </form>

        </div>
        <div  class="d-flex justify-content-center">
            <button mat-flat-button class="btn flat-secondary-button tertiary-bg-button mr-20" (click)="addFundsToCrypto()">Add Funds</button>
            <button mat-flat-button class="btn flat-secondary-button mr-20" (click)="close()">cancel</button>
        </div>
    </div>
</div>